import { Component, HostBinding, OnInit, input } from "@angular/core";

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: "[avTableRow]",
  templateUrl: "./table-row.component.html",
  styleUrls: ["./table-row.component.scss"],
  standalone: false,
})
export class TableRowComponent implements OnInit {
  readonly selectable = input(false);
  readonly active = input(false);

  constructor() {}

  ngOnInit(): void {}

  @HostBinding("class") get class() {
    return {
      "av-table-row-selectable": this.selectable(),
      "av-table-row-active": this.active(),
    };
  }
}
